<template>
    <section class="app-main">
        <el-card >
            <el-table :data="tableData" >
                <el-table-column prop="cid_title" label="销售省份" align="center"></el-table-column>
                <el-table-column prop="gst" label="GST"  align="center"></el-table-column>
                <el-table-column prop="hst" label="HST"  align="center"></el-table-column>
                <el-table-column prop="pst" label="PST"  align="center"></el-table-column>
                <el-table-column prop="qst" label="QST"  align="center"></el-table-column>
                <el-table-column label="编辑" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="mini"  @click="handleShow(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination> -->
        </el-card>
        <!-- 添加 | 修改 弹出框 -->
        <el-dialog :visible.sync="dialog" :title="dialogTitle" align="center" width="750px">
            <div class="items-head">
                <div class="m-width-160"><span>销售省份</span></div>
                <div class="m-width-160"><span>GST</span></div>
                <div class="m-width-160"><span>HST</span></div>
                <div class="m-width-160"><span>PST</span></div>
                <div class="m-width-160"><span>QST</span></div>
            </div>
            <div class="items-body">
                <div class="m-width-160">{{form.cid_title}}</div>
                <div class="m-width-160"><el-input v-model="form.gst" size="small"></el-input></div>
                <div class="m-width-160"><el-input v-model="form.hst" size="small"></el-input></div>
                <div class="m-width-160"><el-input v-model="form.pst" size="small"></el-input></div>
                <div class="m-width-160"><el-input v-model="form.qst" size="small"></el-input></div>
            </div>
           <el-row type="flex" class="line-item" justify="center">
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="info" plain @click="dialog = false" style="width:120px">取消</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="primary" plain @click="handleBtn" style="width:120px">确定</el-button></el-col>
            </el-row>
        </el-dialog>



    </section>
</template>
<script>
import { tax_list,tax_edit } from '@/api/platform.js'
// import { parseTime } from '@/untils/index.js'
export default {
    data() {
        return {
            tableData:[],
            dialog:false,    // 控制显示 添加修改弹窗
            dialogTitle:'修改税率',
            disabled: false,
            form: {
                gst: '',
                hst: '',
                pst: '',
                qst: ''
            },
            id:''
        }
    },
    methods: {
        getData() {
            let params = {
                page:this.page,
            }
            tax_list(params).then(res => {
                if(res) {
                    this.tableData = res.data
                }
            })
        },
        handleShow(row) {
            this.dialog = true
            if(row) {
                this.id = row.id
                this.form.gst = row.gst
                this.form.hst = row.hst
                this.form.pst = row.pst
                this.form.qst = row.qst
                this.form.cid_title = row.cid_title
            }
        },
        // 修改税率
        handleBtn() {
            let params = {
                gst: this.form.gst,               
                hst: this.form.hst,               
                pst: this.form.pst,
                qst: this.form.qst
            }
            tax_edit(this.id,params).then(res => {
                if(res) {
                    this.$message({message: res.msg, type: 'success'})
                    this.dialog = false
                    this.getData()
                }
            })
        }
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .top-btn {
        width: 100px;
    }
    .item-label {
        height: 40px;
        line-height: 40px;
    }
    .line-item {
        margin-top: 25px;
        &:nth-child(1){
            margin-top: 0;
        }
    }
    .m-width-160 {
        width: 160px;
    }
    .items-head{
    width: 700px;
    display: flex;
    background: #f5f7fa;
    border: 1px solid #e8e8e8;
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      padding: 0 8px;
      font-size: 15px;
      color: #8c939d;
      > span {
        display: inline-block;
        width: 100%;
        height: 36px;
        background: #fff;
        text-align: center;
        line-height: 36px;
        border-radius: 3px;
      }
    }
  }
  .items-body{
    width: 700px;
    display: flex;
    border: 1px solid #e8e8e8;
    border-top: none;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 80px;
      padding: 0 8px;
      font-size: 15px;
      color: #8c939d;
    }
    .avatar-uploader-icon {
      width: 60px;
      height: 60px;
      line-height: 60px !important;
      border: 1px solid #e0e0e0;
    }
  }
  /deep/ .el-input--small .el-input__inner {
    text-align: center;
  }
}
</style>
